import moment from "moment";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

import { Quote } from "types/quotes";
import { formatPrice } from "utils/formats";

interface PatientQuoteReportCardProps {
  quote: Quote;
}

const isZeroDate = (value?: string | null) =>
  !value || value.startsWith("0001-01-01");

const formatDate = (value?: string | null) =>
  isZeroDate(value) ? null : moment(value).format("DD/MM/YYYY");

const PatientQuoteReportCard = ({ quote }: PatientQuoteReportCardProps) => {
  const payment = quote.payment;
  const paymentDateDisplay = formatDate(payment?.paymentDate);
  const repasseDateDisplay = formatDate(payment?.paymentLiquidationDate);

  return (
    <div className="row-item mb-2 px-3 pt-3">
      <div className="row align-items-center no-gutters">
        {/* Id do Orçamento */}
        <div className="col col-auto d-flex align-items-center flex-column pb-3 pr-3">
          <div>
            <p className="small opacity-75 mb-0">Id Orçamento</p>
            <b>#{quote.id}</b>
          </div>
        </div>

        {/* Nome do Prestador */}
        <div className="col col-xxl pb-3 px-1">
          <p className="small opacity-75 mb-0">Nome Prestador</p>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>{quote.professional?.name}</Tooltip>}
          >
            <b className="d-block text-md-truncate">
              {quote.professional?.name}
            </b>
          </OverlayTrigger>
        </div>

        <div className="col-12 col-md-8 col-xl-8 col-xxl-6">
          <div className="row">
            {/* Valor Total */}
            <div className="col-12 col-sm-2 col-md-2 pb-3">
              <p className="small opacity-75 mb-0 text-truncate">
                Valor Total
              </p>
              <b>{formatPrice(payment?.value)}</b>
            </div>

            {/* Qtd Parcela */}
            <div className="col-12 col-sm-2 col-md-2 pb-3">
              <p className="small opacity-75 mb-0 text-truncate">Parcelas</p>
              <b>{payment?.parcelQtd}x</b>
            </div>

            {/* Data de Pagamento */}
            <div className="col-12 col-sm-2 col-md-2 pb-3">
              <p className="small opacity-75 mb-0 text-truncate">
                Data do Pagamento
              </p>
              {paymentDateDisplay ? (
                <b>{paymentDateDisplay}</b>
              ) : (
                <p className="opacity-75 mb-0 text-truncate">
                  ---------------
                </p>
              )}
            </div>

            {/* Custo CET */}
            <div className="col-12 col-sm-2 col-md-2 pb-3">
              <p className="small opacity-75 mb-0 text-truncate">
                Custo CET
              </p>
              <b>{formatPrice(payment?.cetCost)}</b>
            </div>

            {/* Valor do Repasse */}
            <div className="col-12 col-sm-2 col-md-2 pb-3">
              <p className="small opacity-75 mb-0 text-truncate">
                Valor de Repasse
              </p>
              <b>{formatPrice(payment?.compensationValue)}</b>
            </div>

            {/* Data de Repasse */}
            <div className="col-12 col-sm-2 col-md-2 pb-3">
              <p className="small opacity-75 mb-0 text-truncate">
                Data de Repasse
              </p>
              {repasseDateDisplay ? (
                <b>{repasseDateDisplay}</b>
              ) : (
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip>
                      Cartão aprovado, repasse ainda não foi efetuado
                    </Tooltip>
                  }
                >
                  <span className="badge bg-warning text-dark">Pendente</span>
                </OverlayTrigger>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PatientQuoteReportCard;
